module.exports = {"230811001":"佳西街道","230811002":"友谊街道","230811101":"大来镇","230811102":"敖其镇","230811103":"望江镇","230811104":"长发镇","230811105":"莲江口镇","230811106":"西格木镇","230811200":"长青乡","230811201":"沿江乡","230811208":"平安乡","230811210":"四丰乡","230811211":"群胜乡","230811480":"莲江口监狱","230811579":"郊区农垦"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230811.json
// module id = 761
// module chunks = 0